import {
  Box,
  Button,
  ButtonProps,
  Card,
  Container,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Pagination,
  PaginationItem,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, {
  ChangeEvent,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import variables from "../../../assets/styles/variables.module.scss";
import { useDispatch } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import DataCard from "../../../Shared-ui/SharedComponents/Cards/MediumCardData";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import SearchIcon from "@mui/icons-material/Search";
import { Filter } from "@mui/icons-material";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import { AGENT, DELETE_AGENT, LIST_AGENT } from "../../../Services/Endpoint";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { count } from "console";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import { NotSelected, DefaultGroupList, UserRole } from "../../../Constant/Setting";
import CreateAgent from "../../Components/CreateAgent";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import Confirm from "../../../Shared-ui/Types/Confirm";
import CommonContext from "../../../Shared-ui/Context/CommonContext";
import Agent_emptystateimage from "../../../assets/images/Agents_emptystateimage.svg";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { Agent } from "../../../Shared-ui/Types/Agent";
import AgentCard from "../../../Shared-ui/SharedComponents/Cards/AgentCard";
import userContext from "../../../Shared-ui/Context/UserContext";



interface MyComponentProps {
  refreshTab?: boolean
  tabId?: number;
}


const DashboardAgents: React.FC<MyComponentProps> = (props) => {
  const { commonState, updateCommonContext } = useContext(CommonContext);
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [agents, setAgents] = useState<Agent[]>([]);
  
  const [agentsAll, setAgentsAll] = useState<Agent[]>([]);
  const [agent, setAgent] = useState<Agent | null>(null);
  const [searchText, setSearchText] = useState<string>("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(4);
  const pageLimitRef = useRef(4);
  const prevPage = useRef<number>(page);
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({
    show: false,
  });
  const [filteredAgents, setFilteredAgents] = useState<Agent[]>([]);
  const [totalAgents, setTotalAgents] = useState<number>(0);

  const { user } = useContext(userContext); 
  const user_role = user?.role;
  const isSuperAdmin = user_role === "super admin";
  console.log(isSuperAdmin,"isSuperAdmin")

  useEffect(() => {
    if (!searchText) {
      getAgents();
    }
  }, [searchText]);

  // Paginate locally
  const paginatedAgents = (data: Agent[]) => {
    const dataPaginated = data.slice(
      (page - 1) * pageLimitRef.current,
      page * pageLimitRef.current
    );
    setAgents(dataPaginated);
  };

  useEffect(() => {
    if (prevPage.current !== page) {
      getAgents();
      // paginatedAgents(filteredAgents);
      prevPage.current = page;
    }
  }, [page,]);

  const getAgents = async (filter?: string, searchText?: string) => {
    try {
      dispatch(StartLoading("Agent"));
      if (isSuperAdmin) {
        return;
      }
      var url = `${AGENT}?page=${page}&page_size=${limit}`
      if (filter) {
        url += `&filter=${filter}`;
      } else if (searchText) {
        url += `&search=${searchText}`;
      }
      const data = await BaseInstance.get(url).then((res) => res?.data);
      data?.items.sort(
        (a: { created_at: string }, b: { created_at: string }) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setTotalAgents(data.pagination.total || 0);
      setAgents(data.items || []);
      // setAgents(data)
      // setAgentsAll(data);
      // setFilteredAgents(data);
      // paginatedAgents(data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.details));
    } finally {
      dispatch(StopLoading("Agent"));
    }
  };

  const deleteAgent = async () => {
    try {
      dispatch(StartLoading());
      const data = await MetaInstance.delete(`${DELETE_AGENT}`).then(
        (res) => res?.data?.detail
      );
      // const groupNames = data.response?.map((item: Group) => item.name)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading());
    }
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };
  const handleSearch = () => {
    setPage(1);
    getAgents(undefined, searchText);
  };
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
          pb: 3,
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            display: "flex",
            border: `1px solid ${variables.borderColor}`,
            borderRadius: "8px",
            backgroundColor: "rgba(256, 256, 256, 0.7)",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", sm: "250px" },
            }}
          >
            <OutlinedInput
              fullWidth
              // variant="outlined"
              size="small"
              placeholder="Search Agent"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    edge="end"
                    onClick={() => handleSearch()}
                  >
                    <SearchIcon fontSize="inherit" />
                  </IconButton>
                </InputAdornment>
              }
              sx={{
                height: "30px",
                pr: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "& input": {
                  padding: "14px ", // Vertically center text
                },
              }}
            />
          </Box>
        </Box>
        {totalAgents > limit && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Pagination
              count={Math.ceil(totalAgents / limit)}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              shape="rounded"
              sx={{
                ul: {
                  display: "flex",
                  flexWrap: "nowrap", // Ensures items do not wrap
                },
              }}
            />
            {/* <Pagination
                count={Math.ceil(agentCount / pageSize)}
                page={page}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
              /> */}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xl: "repeat(4, minmax(0, 1fr))",
            lg: "repeat(4, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
            sm: "repeat(2, minmax(0, 1fr))",
          },
          gap: 4,
          gridAutoRows: "1fr",
          minHeight: 200, // ensures some height so message isn't cramped
          placeItems: agents.length === 0 ? "center" : "start",
        }}
      >
        {/* Agent list */}
        {agents.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              gridColumn: "1 / -1", // span all columns
            }}
          >
            <img
              src={Agent_emptystateimage}
              alt="No Agents"
              style={{ width: 120, height: "auto" }}
            />
            <Typography variant="h6" fontWeight="textsecondary">
              No agent found
            </Typography>
          </Box>
        ) : (
          agents.map((agent: Agent, index: number) => (
            <Card
              //elevation={6}
              sx={{
                borderRadius: "12px",
                width: "100%",
                boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                backgroundColor: "rgba(256, 256, 256, 0.7)",
                backdropFilter: "blur(5px)",
              }}
              key={index}
            >
              <AgentCard
                agent={agent}
                deleteFun={deleteAgent}
                editFun={() => { }}
                hideDelete={true}
                hideUpdate={true}
              />
              {/* <DataCard data={agent} key={index} /> */}
            </Card>
          ))
        )}

        {/* {agentsList.map((agent: Agent, index: number) => (
          
        ))} */}
      </Box>
      {/* {agentsList.length === 0 && (
        <Typography fontWeight="600" sx={{ pt: 3, pb: 2, textAlign: "center" }}>
          No Record Found
        </Typography>
      )} */}
      <ConfirmPopup details={confirmPopupData} />
    </Box>
  );
};

export default DashboardAgents;
